export const globalStateKey = '__ecore2';
export const store = () => global[globalStateKey] && global[globalStateKey].store;

export function addDynamicSaga(name, saga) {
    store().dynamicSagas[name] = saga;
}

export function setDynamicReducers(reducers) {
    store().dynamicReducers = reducers;
}
